export class DatabaseFile {
  /**
   * DatabaseFile constructor
   *
   * @param {number} id
   * @param {string} name
   * @param {string} url
   */
  constructor(id, name, url) {
    this.id = id;
    this.name = name;
    this.url = url;
  }
}
